<template>
  <ModelListPage
          lower-app-name="emarket"
          lower-model-name="goods"
          version="2"
          title="商品列表">
  </ModelListPage>
</template>

<script>
import ModelListPage from './ModelListPage.vue'

export default {
  name: 'GoodsList',
  components: {
    ModelListPage
  }
}
</script>



// WEBPACK FOOTER //
// GoodsList.vue?65c09b06